import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPettyCashRequestList = createAsyncThunk("fetchPettyCashRequestList", async ({ filters }) => {
	const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");

	const params = new URLSearchParams({
		page: filters?.page ?? 1,
		limit: filters?.limit ?? 10,
		keyword: filters?.keyword ?? "",
		status_id: filters?.status_id ?? "",
		department: filters?.department_id ?? "",
		float_id: filters?.float_id ?? "",
		user: filters?.user ?? "",
		start_date: filters?.dateRange && filters.dateRange[0] ? formatDate(filters.dateRange[0]) : "",
		end_date: filters?.dateRange && filters.dateRange[1] ? formatDate(filters.dateRange[1]) : "",
	});

	try {
		const response = await axiosHttp.get(`petty-cash/requests?${params}`);
		return response.data;
	} catch (error) {
		throw error;
	}
});

const PettyCashRequestListSlice = createSlice({
	name: "PettyCashRequestListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		limit: 10,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashRequestList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPettyCashRequestList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.pagination?.page || action.payload?.page || 1;
			state.limit = action.payload?.pagination?.limit || action.payload?.limit || 10;
			state.total = action.payload?.pagination?.total || action.payload?.total || (action.payload?.data ? action.payload.data.length : 0);
		});
		builder.addCase(fetchPettyCashRequestList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default PettyCashRequestListSlice.reducer;
